<template>
    <Modal v-model="visible" :title="title" :width="60">
        <div style="height: 500px;overflow:auto">
            <div style="color: #fff;background:#2d98f1;padding:10px 20px;border-radius: 8px;font-size: 12px">
                新增的文件：共{{ data.insertCount }}个
            </div>
            <div style="margin-top: 10px;display:flex;flex-wrap: wrap;">
                <div v-for="(item,index) in data.insertList" :key="item.name+'-'+index" style="padding: 5px 10px;font-size: 14px;">
                    <div style="padding: 3px 10px;background:#e5f0ff;border-radius: 90px;">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div v-if="!!data.updateCount">
                <Divider />
                <div style="color: #fff;background:#ffd059;padding:10px 20px;border-radius: 8px;font-size: 12px;">
                    已存在待替换的文件：共{{ data.updateCount }}个
                </div>
                <div style="margin-top: 10px;display:flex;flex-wrap: wrap;">
                    <div v-for="(item,index) in data.updateList" :key="item.name+'-'+index" style="padding: 5px 10px;font-size: 14px;">
                        <div style="padding: 3px 10px;background:#ffeec2;border-radius: 90px;">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!!(data.wrongNameCount+data.overMaxNumCount)">
                <Divider />
                <div style="color: #fff;background:#ced4db;padding:10px 20px;border-radius: 8px;font-size: 12px;">
                    异常文件：共{{ data.wrongNameCount+data.overMaxNumCount }}个
                </div>
                <div v-if="!!data.wrongNameCount">
                    <div style="display: flex;justify-content: space-between;padding:0 10px;margin-top: 10px;font-size:14px">
                        <div>命名不规范</div>
                        <div>共{{ data.wrongNameCount }}个</div>
                    </div>
                    <div style="margin-top: 10px;display:flex;flex-wrap: wrap;">
                        
                        <div v-for="(item,index) in data.wrongNameList" :key="item.name+'-'+index" style="padding: 5px 10px;font-size: 14px;">
                            <div style="padding: 3px 10px;background:#ced4db;border-radius: 90px;">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!!data.overMaxNumCount">
                    <Divider style="margin: 10px 0" />
                    <div style="display: flex;justify-content: space-between;padding:0 10px;font-size:14px">
                        <div>超出设定集数</div>
                        <div>共{{ data.overMaxNumCount }}个</div>
                    </div>
                    <div style="margin-top: 10px;display:flex;flex-wrap: wrap;">
                        
                        <div v-for="(item,index) in data.overMaxSeriesNumList" :key="item.name+'-'+index" style="padding: 5px 10px;font-size: 14px;">
                            <div style="padding: 3px 10px;background:#ced4db;border-radius: 90px;">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <template #footer>
            <Button @click="visible = false">取消</Button>
            <Button @click="handleCheck" type="primary">确认</Button>
        </template>
    </Modal>
</template>

<script>
export default {
    props: {
        data: {
            type:Object,
            default:()=>({
                insertCount: 0,
                insertList: [],
                overMaxNumCount: 0,
                overMaxSeriesNumList: [],
                path: '',
                placeholderList: [],
                totalCount: 0,
                updateCount: 0,
                updateList: [],
                wrongNameCount: 0,
                wrongNameList: []
            })
        }
    },
    data(){
        return {
            visible: false,
            title: '百度云上传'
        }
    },
    methods:{
        handleCheck(){
            this.visible = false
            this.$emit('getList', this.data.placeholderList)
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-modal-wrap{
    z-index: 1001 !important;
}
/deep/.ivu-modal-mask{
    z-index: 1001 !important;

}
</style>